import script from "./StickerGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickerGallery.vue?vue&type=script&setup=true&lang=ts"

import "./StickerGallery.vue?vue&type=style&index=0&id=5bc61e2e&lang=scss"

const __exports__ = script;

export default __exports__